import template from 'product-right-rail.j2';
import { generate } from '../../../core/js/utils/componentUtils';
import { init as rrInit } from '../../../core/js/components/richRelevanceComponent';

import { isRightRailActive, isRightRailEnabled, getDYPlacementIdFromSettings } from '../../../core/js/utils/rrUtils';
import { sanitizePlacementId } from '../../../core/js/utils/recommendationsUtils';

function generateDictionary(state) {
    const data = {
        isRightRailActive: isRightRailActive(state, this.placementKey),
        isRightRailEnabled: isRightRailEnabled(state)
    };

    return Object.assign({}, state, data);
}

export function onStateChange(store) {
    const dictionary = this.generateDictionary(this.store.getState());

    this.render(store, this, dictionary);
}

export function init(store, overrides = {}) {
    const placementKey = sanitizePlacementId(getDYPlacementIdFromSettings(store.getState(), 'productPrimary'));
    const config = {
        placementKey: placementKey,
        templateLocation: '.dom-product-right-rail',
        watch: [`core.rrRecs.${placementKey}.recs`, 'core.deviceCharacteristics'],
        onStateChange: onStateChange,
        generateDictionary: generateDictionary,
        template: template,
        children: [
            [rrInit, {
                templateLocation: '.dom-product-right-rail .dom-rr-container',
                rrPlacement: placementKey,
                watch: [`core.rrRecs.${placementKey}.recs`, 'core.deviceCharacteristics'],
                isRightRail: true,
                isSwiper: false,
                isComponentValid: () => isRightRailEnabled(store.getState())
            }]
        ]
    };

    return generate(config, store, overrides);
}
